/*
  Standalone entry: an ordinary Vite site (deployable as an nsite) with no
  shell. Reads the tree from its own default relays and cannot compose.

  Overrides, in priority order: `?root=` / `?relays=` URL params, then the
  build-time `VITE_ROOT` / `VITE_RELAYS` values, then the shared defaults.
*/
import { startProblemTreeApp } from "./app";
import { ROOT_A_TAG } from "./core/problem-dag";
import { createWebHost } from "./host/web-host";

const params = new URLSearchParams(window.location.search);

const parseRelays = (value: string | null | undefined) =>
  (value ?? "").split(",").map((relay) => relay.trim()).filter(Boolean);

const relays = [...parseRelays(params.get("relays")), ...parseRelays(import.meta.env.VITE_RELAYS)];
const root = params.get("root") ?? import.meta.env.VITE_ROOT ?? ROOT_A_TAG;

startProblemTreeApp(createWebHost({
  // Left undefined so the host keeps its default read set plus the fallback
  // tier; an explicit request replaces both with exactly those relays.
  relays: relays.length ? relays : undefined,
  onRootChange: (coordinate) => {
    const url = new URL(window.location.href);
    url.searchParams.set("root", coordinate);
    window.history.replaceState(null, "", url);
  }
}), { initialRoot: root || undefined });
